import { LoadingOutlined } from '@ant-design/icons';
import { Flex, Spin } from 'antd';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { addReturnUrl } from '../../helpers';
import { useCheckAuth } from '../../hooks/use-check-auth';
import { AuthParams } from '../../types';

export default function AuthGuardClientCheck({
  authParams,
  children,
  hideCallbackUrl,
  redirectTo,
}: {
  authParams: AuthParams;
  children: React.ReactNode;
  hideCallbackUrl: boolean;
  redirectTo: string;
}) {
  const navigate = useNavigate();
  const { isLoaded, isPermitted } = useCheckAuth(authParams);

  useEffect(() => {
    if (isLoaded && !isPermitted) {
      const url = hideCallbackUrl ? redirectTo : addReturnUrl(redirectTo, window.location.href);
      navigate(url, { replace: true });
    }
  }, [hideCallbackUrl, isLoaded, isPermitted, redirectTo, navigate]);

  if (!isLoaded || !isPermitted) {
    return (
      <Flex align="center" justify="center" style={{ height: '100vh' }}>
        <Spin indicator={<LoadingOutlined spin style={{ fontSize: 66 }} />} />
      </Flex>
    );
  }

  return children;
}
